import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/auth/AuthProvider";
import { Card, CardContent } from "@/components/ui/card";
import { Loader2, BookOpen, CheckCircle2, XCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const Route = createFileRoute("/_authenticated/student/quizzes")({
  component: StudentQuizzes,
});

function StudentQuizzes() {
  const { user } = useAuth();
  const [attempts, setAttempts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    async function loadQuizzes() {
      const { data } = await supabase
        .from("quiz_attempts")
        .select("id, score, max_score, percentage, passed, completed_at, quizzes(title)")
        .eq("student_id", user?.id || "")
        .order("completed_at", { ascending: false });

      setAttempts(data || []);
      setLoading(false);
    }
    loadQuizzes();
  }, [user]);

  if (loading)
    return (
      <div className="flex justify-center p-10">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-extrabold flex items-center gap-3">
        <BookOpen className="h-8 w-8 text-primary" /> اختباراتي
      </h1>
      {attempts.length === 0 ? (
        <Card className="rounded-3xl border-dashed">
          <CardContent className="p-10 text-center">
            <p className="text-muted-foreground">لم تقم بأداء أي اختبارات بعد.</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {attempts.map((a) => (
            <Card key={a.id} className="rounded-2xl border-0 shadow-soft">
              <CardContent className="p-5 flex items-center gap-4">
                <div
                  className={`p-3 rounded-full ${a.passed ? "bg-success/10 text-success" : "bg-destructive/10 text-destructive"}`}
                >
                  {a.passed ? (
                    <CheckCircle2 className="h-6 w-6" />
                  ) : (
                    <XCircle className="h-6 w-6" />
                  )}
                </div>
                <div className="flex-1">
                  <h3 className="font-bold">{a.quizzes?.title}</h3>
                  <div className="flex gap-3 text-sm text-muted-foreground mt-1">
                    <span>
                      النتيجة: {a.score}/{a.max_score} ({a.percentage}%)
                    </span>
                    <span>{new Date(a.completed_at).toLocaleDateString("ar-EG")}</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
